import { useMemo } from "react";
import { useIntercom } from "react-use-intercom";

import useBasicData from "@/hooks/useBasicData";
import { useWorkspaceMembership } from "@/hooks/useWorkspaceMembership";

import { WorkspaceDropdown } from "../WorkspaceDropdown/WorkspaceDropdown";

export const WorkspaceSelectionButton = () => {
  const { activeWorkspace, user } = useBasicData();
  const { filteredMemberships } = useWorkspaceMembership();

  const workspaces = useMemo(() => {
    const mapped = filteredMemberships.map((membership) => ({
      ...membership.workspace,
      displayName: membership.workspace.displayName ?? undefined,
      profilePicture: membership.workspace.profilePicture ?? undefined,
      planTier: membership.workspace.planTier ?? undefined,
    }));

    const activeIsIncluded =
      activeWorkspace && mapped.some((ws) => ws.id === activeWorkspace.id);

    if (activeWorkspace && !activeIsIncluded) {
      mapped.unshift({
        ...activeWorkspace,
        displayName: activeWorkspace.displayName ?? undefined,
        profilePicture: activeWorkspace.profilePicture ?? undefined,
        planTier: activeWorkspace.planTier ?? undefined,
      });
    }

    return mapped;
  }, [filteredMemberships, activeWorkspace]);

  const { showNewMessage } = useIntercom();

  if (!activeWorkspace || workspaces.length === 0) {
    return null;
  }

  return (
    <WorkspaceDropdown
      allWorkspaces={workspaces}
      currentWorkspaceId={activeWorkspace.id}
      userEmail={user?.email ?? ""}
      userFullName={user?.name ?? undefined}
      userProfilePictureUrl={user?.profilePicture ?? undefined}
      handleIntercomMessage={showNewMessage}
    />
  );
};
